import React, { useEffect, useState } from 'react';
import { ComponentChoices, completeComponentChoices, composedQuote } from './ComposedMealBuilder';
import { formatPrice } from '../../utils/currency';

// Drafts stay in the parent tray until the whole delivery is confirmed.
export default function InlineComposedMeal({ plan, day, subdomain, storeId, onAdd }) {
  const [options, setOptions] = useState(null);
  const [picks, setPicks] = useState({});
  const [error, setError] = useState('');
  const [open, setOpen] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setOptions(null); setError(''); setPicks({}); setOpen(false);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/storefront/meal-pack-options/${encodeURIComponent(subdomain)}/${encodeURIComponent(plan.id)}?store_id=${encodeURIComponent(storeId)}`, {signal: controller.signal})
      .then(async response => { const data = await response.json(); if (!response.ok) throw new Error('Unable to load Build Your Own. Try again.'); return data; })
      .then(data => { if (!controller.signal.aborted) setOptions(data); })
      .catch(err => { if (!controller.signal.aborted) setError(err.message); });
    return () => controller.abort();
  }, [plan.id, subdomain, storeId, day, attempt]);
  const config = options?.selling?.pricing_mode === 'category_meal' ? options.selling.composed_meal : null;
  const selectedDate = options?.dates?.find(d => d.date === day);
  const available = (options?.items || []).filter(i => (options?.items_by_date?.[day] || []).includes(i.item_id));
  const complete = config && selectedDate && completeComponentChoices(config, picks, available);
  const price = config ? composedQuote(config, picks) : 0;
  const money = value => formatPrice(value, options?.currency);
  return <section className="rounded-xl border p-4 my-4" aria-label={plan.alias || plan.name}>
    <h3 className="font-semibold">{plan.alias || plan.name}</h3>
    {error ? <p role="alert">{error} <button type="button" onClick={() => setAttempt(n => n + 1)}>Retry</button></p> : !options ? <p role="status">Loading Build Your Own…</p> : !config || !selectedDate ? <p>Not available for this delivery date.</p> : <>
      <p>Choose your protein, sides and extras. {money(config.base_price)} before upgrades.</p>
      <button type="button" className="mp-text-button" aria-expanded={open} onClick={() => setOpen(value => !value)}>{open ? 'Close builder' : 'Build a meal'}</button>
      {open && <div className="mt-4 space-y-4"><ComponentChoices config={config} picks={picks} setPicks={setPicks} available={available} money={money} />
        <div className="flex items-center justify-between gap-3"><strong>{money(price)}</strong><button type="button" className="mp-primary" disabled={!complete} onClick={() => {
          if (!complete) return;
          const selections = Object.entries(picks).map(([item_id, quantity]) => ({item_id, quantity}));
          onAdd({plan: {...plan, currency: options.currency}, selections, price, day,
            revision: options.menus_by_date[day].revision, cutoffAt: selectedDate.cutoff_at, timezone: options.timezone,
            names: selections.map(p => ({...p, quantity: 1, name: `${available.find(i => i.item_id === p.item_id)?.name}${p.quantity === 2 ? ' (Double portion)' : ''}`}))});
          setPicks({});
        }}>Add meal</button></div>
      </div>}
    </>}
  </section>;
}
